/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, prettyHour } from '../utils/util';
import './Team.css';
import Wrapper from './Wrapper';
import {
  fetchUser,
  getTeam,
  updateTeam,
} from '../actions';

import EscapeList from './partials/EscapeList';
import TeamForm from './partials/TeamForm';
import Badge from './partials/Badge';
import EscapeStats from './partials/EscapeStats';


class Team extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['team', getTeam, p => p.id],
  ];

  state = {};

  editTeam(e, values) {
    e.preventDefault();
    let team = this.props.team;
    let profile = this.props.profile;
    this.props.updateTeam(team.id, values)
      .then(resp => {
        console.log('update team resp:', resp);
        if (resp.error) return;
        this.props.getTeam(team.id, { background: true })
          .then(() => this.closeEditTeam());
      });
  }

  closeEditTeam() {
    this.setState({ editingTeam: false });
  }

  renderEditTeam() {
    let team = this.props.team;
    if (!team) return;

    return (
      <Modal show={!!this.state.editingTeam}>
        <Modal.Header closeButton onHide={() => this.closeEditTeam()}>
          <Modal.Title>Edit Team</Modal.Title>
        </Modal.Header>
        <TeamForm
          modal={true}
          values={team}
          errors={this.props.errors.team}
          onSubmit={(e, values) => this.editTeam(e, values)}
          onCancel={() => this.closeEditTeam()}
          buttonText="Save"
          cancelText="Cancel"
        />
      </Modal>
    );
  }

  renderTeam() {
    let team = this.props.team;
    let user = this.props.user;
    // if (!team || !user) return;

    let memberNodes = [];
    let isSelf;
    if (team) {
      memberNodes = team.members.map(m => {
        return (
          <div className="member" key={m.id}>
            <Badge profile={m} />
          </div>
        )
      });
      for (let m of team.members) {
        if (m.username == user.username) {
          isSelf = true;
        }
      }
    }

    let title = team ? team.name : '';
    let escapes = team ? team.escapes : [];

    return (
      <div>
        <EscapeStats title={title} escapes={escapes} />

        <hr />
        <div className="content">
          <div className="members-inner">
            <div className="members">
              <div className="small-caps-black-header">Members</div>
              {memberNodes}
              <Button onClick={() => this.setState({ editingTeam: true})}>Edit</Button>
            </div>

            {team && team.photo && <div className="photo"><img src={team.photo} /></div>}
          </div>
        </div>
        <hr />

        <div className="content">
          <EscapeList
            title={title + ' Escapes'}
            isSelf={isSelf}
            user={user}
            team={team}
            escapes={escapes}
            onChange={() => this.props.getTeam(team.id, { background: true })}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="Team no-title" title="">
        {this.renderEditTeam()}
        {this.renderTeam()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    team: state.get.team,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getTeam,
    updateTeam,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Team);



/** WEBPACK FOOTER **
 ** ./src/components/Team.js
 **/